
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blocks",
      function () {
        return require("private-next-pages/blocks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blocks"])
      });
    }
  